import React from 'react';
import useFetchAllData from 'Hooks/useFetchAllData';
import PageBody from 'Common/Custom/PageBody';
import FormSubmitButton from 'Common/Custom/FormSubmitButton';
import FormSelect from 'Common/Custom/FormSelect';
import { HeadingOne } from 'Common/Custom/HeadingOne';
import { GetAllFacilitiesList, GetAllRoomsTypeList } from 'adminApi/AssignRoomFacilitiesApi/AssignRoomFacilities';
import RoomFacilitiesCheckboxGroup from './RoomFacilitiesCheckboxGroup';

const AssignRoomFacilitiesForm = ({
    fields = [],
    values,
    errors,
    handleChange,
    handleSubmit,
    loading,
    title = "Assign Room Facilities",
    setValues,
}) => {
    const { data: roomTypeOptions } = useFetchAllData(GetAllRoomsTypeList);
    const { data: facilityOptions } = useFetchAllData(GetAllFacilitiesList);

    return (
        <PageBody
            headerchildren={<HeadingOne>{title}</HeadingOne>}
            onSubmit={handleSubmit}
        >
            {fields.map((field) => {
                if (field.type === "select") {
                    const options = (roomTypeOptions || []).map((opt) => ({
                        value: opt.room_id,
                        label: opt.room_type,
                    }));
                    return (
                        <FormSelect
                            key={field.name}
                            field={field}
                            value={values[field.name]}
                            handleChange={handleChange}
                            options={options}
                            error={errors[field.name]}
                        />
                    );
                }

                if (field.type === "checkbox") {
                    // Only render checkbox group when a room type is selected
                    // Use strict check to avoid hiding when room_type is 0
                    if (!values.room_type && values.room_type !== 0) return null;

                    return (
                        <RoomFacilitiesCheckboxGroup
                            key={field.name}
                            field={field}
                            values={values}
                            setValues={setValues}
                            facilityOptions={facilityOptions || []}
                        />
                    );
                }

                return null;
            })}

            {/* Fixed label — button always says "Save" regardless of title */}
            <FormSubmitButton
                label="Save"
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

export default AssignRoomFacilitiesForm;
